// src/App.jsx — v9.2 Launch
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout         from "./layout/MainLayout";
import AnalyzePage        from "./pages/AnalyzePage";
import Dashboard          from "./pages/Dashboard";
import Finance            from "./pages/Finance";
import AlertsPage         from "./pages/AlertsPage";
import LogsPage           from "./pages/LogsPage";
import Settings           from "./pages/Settings";
import ArbitragePage      from "./pages/ArbitragePage";
import IngestionPage      from "./pages/IngestionPage";
import EngineSettingsPage from "./pages/EngineSettingsPage";
import TestLabPage        from "./pages/TestLabPage";
import ReportsPage        from "./pages/ReportsPage";
import ScreenshotUpload   from "./pages/ScreenshotUpload";

export default function App() {
  return (
    <MainLayout>
      <Routes>
        <Route path="/"            element={<Navigate to="/analyze" replace />} />
        <Route path="/analyze"     element={<AnalyzePage />} />
        <Route path="/dashboard"   element={<Dashboard />} />
        <Route path="/ingestion"   element={<IngestionPage />} />
        <Route path="/logs"        element={<LogsPage />} />
        <Route path="/finance"     element={<Finance />} />
        <Route path="/alerts"      element={<AlertsPage />} />
        <Route path="/arbitrage"   element={<ArbitragePage />} />
        <Route path="/settings"    element={<Settings />} />
        <Route path="/engine"      element={<EngineSettingsPage />} />
        <Route path="/test"        element={<TestLabPage />} />
        <Route path="/reports"     element={<ReportsPage />} />
        <Route path="/screenshot"  element={<ScreenshotUpload />} />
      </Routes>
    </MainLayout>
  );
}
